<div class="promotions-shell">
  <nav class="promotions-shell__tabs" [attr.aria-label]="'promotions.title' | translate">
    @for (tab of topTabs; track tab.id) {
      <button
        type="button"
        class="promotions-shell__tab"
        [class.promotions-shell__tab--active]="tab.id === selectedTopTabId"
        (click)="onTopTabClick(tab.id)"
      >
        {{ tab.label | translate }}
      </button>
    }
  </nav>

  <router-outlet></router-outlet>
</div>
